import wixData from 'wix-data';

$w.onReady(function () {

	let govDocsNum;
	let committeeDocsNum;

	$w("#governanceDocsRepeater").onItemReady( ($w, itemData, index) => {
		$w("#GdItemTitle").text = itemData.title;
		$w('#GdItemFile1').link = itemData.file;
		$w("#governanceDocsRepeater").expand();
		
		if( (index + 1) === govDocsNum ){
			$w('#governanceDocsSep').collapse();
		}
	});
	
	wixData.query("governanceDocsDatabase")
		.eq("category", "Governance")
		.find()
		.then((results) => {
			govDocsNum = results._items.length;
			$w('#governanceDocsRepeater').data = results._items;
		})
		.catch((error) => {
			let errorMsg = error.message;
			let code = error.code;
	});

	$w("#committeeRepeater").onItemReady( ($w, itemData, index) => {
		$w("#CcItemTitle").text = itemData.title;
		$w('#CcItemFile1').link = itemData.file;
		$w("#governanceDocsRepeater").expand();

		if( (index + 1) === committeeDocsNum ){
			$w('#committeeDocsSep').collapse();
		}
	});
	
	wixData.query("governanceDocsDatabase")
		.eq('category', 'Committee')
		.find()
		.then((results) => {
			committeeDocsNum = results._items.length;
			$w('#committeeRepeater').data = results.items;
		})
		.catch((error) => {
			let errorMsg = error.message;
			let code = error.code;
	});
});